<div class="section">
    <div class="content" style="margin: 10px 16px">
        <p class="text_16_b" style="display: inline-block;margin-top: 10px;">Load New Files</p>
    </div>
    <div class="content" style="margin: 0px 16px;padding-bottom: 21px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
        <div style="display: inline-block; border-right: 1px solid #c4c4c4; padding-right: 20px;">
            <p class="text_12">New Batch Key</p>
            <p *ngIf="!batchKey" class="text_14">Submit saved configurations to generate a New Batch Key</p>
            <p *ngIf="batchKey" class="text_14">{{batchKey}}</p>
        </div>
        <div *ngIf="batchKey"
            style="display: inline-block; border-right: 1px solid #c4c4c4; margin-left: 20px; padding-right: 20px;min-width: 100px;">
            <p class="text_12">Status</p>
            <p *ngIf="batchKey" class="text_14">New </p>
        </div>
        <div *ngIf="batchKey" style="display: inline-block; margin-left: 20px;">
            <p class="text_12">Selected Cloud Instance</p>
            <p *ngIf="batchKey" class="text_14">{{selectedInstance?.INSTANCE}} </p>
        </div>

        <div style="float: right;">
            <button mat-flat-button class="green-button submit-file-upload" (click)="onLoadClick()"
                [disabled]="submitNewBtnDisable"> Submit File Upload
            </button>
            <div
                style="float: right;margin-right: 8px;margin-top: 10px;min-width: 120px;color: #0D8390; font-size: 12px!important;">
                <div style="display: inline-block;vertical-align: middle;margin-top: 5px;margin-right: 5px;cursor: pointer;"
                    (click)="editConfig()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="11" stroke="#0D8390" stroke-width="2" />
                        <path
                            d="M6 15.4974V17.9971H8.49965L15.872 10.6248L13.3723 8.12511L6 15.4974ZM17.805 8.6917C18.065 8.43173 18.065 8.01179 17.805 7.75183L16.2452 6.19204C15.9853 5.93208 15.5653 5.93208 15.3054 6.19204L14.0855 7.41187L16.5852 9.91153L17.805 8.6917Z"
                            fill="#0D8390" />
                    </svg>
                </div> <span style="font-weight: bold; font-size: 12px;cursor: pointer" (click)="editConfig()">Edit
                    Configurations</span>
            </div>
        </div>
    </div>
    <div class="tracks-class">
        <div *ngFor="let configItem of taskList; let i= index">
            <ng-container class="b-spacing container" *ngIf="configItem.download_template =='Y'">
                <div class="item" style="width:50%; float:left">
                    <div>
                        <div class="gray-bg">
                            <p class="font-w-b">{{configItem.task_name}}</p>
                            <div>Upload extract file <div class="tooltip"><img src="./assets/Info.svg" alt="Image 1"
                                        class="tool-info" /><span class="tooltiptext1">Supported file
                                        format: .zip, .xlm</span></div>
                            </div>
                            <input #fileInput style="display: none;"
                                (click)="onFileInputClicked(fileInput, configItem,i)" type="file" name="fileData"
                                (change)="onFileSelectedForCsvExtract($event, configItem.task_name, configItem.file_name)"
                                class="form-control1 upload-icon" accept=".zip, .xlsm" />
                            <input #fileText type="text" [(ngModel)]="myFiles[i]" (click)="fileInput.click()"
                                (keydown)="$event.preventDefault();" class="form-control-text upload-icon-text"
                                placeholder="No file chosen" />
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>